import { translationTestPortals_da } from "./translationTestPortals.da";
import { defineBilingualTranslations } from "./translationTypes";
import { translationTestPortals_en } from "./translationTestPortals.en";

export const translationTestPortals = defineBilingualTranslations({
  da: translationTestPortals_da,
  en: translationTestPortals_en,
});
